import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const committeeMeetingsApi = {
    getCommitteeMeetings: (committeeId: number): Observable<Dtos.GetCommitteeMeetingsResponse> => {
        //Create the request.
        let request: Dtos.GetCommitteeMeetings = new Dtos.GetCommitteeMeetings();
        request.committeeId = committeeId;

        //Send request.
        const response: Promise<Dtos.GetCommitteeMeetingsResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getCommitteeMeetingById: (id: number): Observable<Dtos.GetCommitteeMeetingByIdResponse> => {
        //Create the request.
        let request: Dtos.GetCommitteeMeetingById = new Dtos.GetCommitteeMeetingById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetCommitteeMeetingByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getCommitteeMeetingByCommitteeId: (committeeId: number): Observable<Dtos.GetCommitteeMeetingByCommitteeIdResponse> => {
        //Create the request.
        let request: Dtos.GetCommitteeMeetingByCommitteeId = new Dtos.GetCommitteeMeetingByCommitteeId();

        request.committeeId = committeeId;

        //Send request.
        const response: Promise<Dtos.GetCommitteeMeetingByCommitteeIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setCommitteeMeeting: (committeeMeeting: Dtos.CommitteeMeeting): Observable<Dtos.SetCommitteeMeetingResponse> => {

        let request: Dtos.SetCommitteeMeeting = new Dtos.SetCommitteeMeeting();

        request.committeeMeeting = committeeMeeting;

        // send request
        const response: Promise<Dtos.SetCommitteeMeetingResponse> = client.post(request);

        return Observable.from(response);
    },
    createCommitteeMeeting: (committeeId: number): Observable<Dtos.CreateCommitteeMeetingResponse> => {
        //Create the request.
        let request: Dtos.CreateCommitteeMeeting = new Dtos.CreateCommitteeMeeting();

        request.committeeId = committeeId;

        //Send request.
        const response: Promise<Dtos.CreateCommitteeMeetingResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateCommitteeMeeting: (committeeMeeting: Dtos.CommitteeMeeting): Observable<Dtos.ValidateCommitteeMeetingResponse> => {

        let request: Dtos.ValidateCommitteeMeeting = new Dtos.ValidateCommitteeMeeting();

        request.committeeMeeting = committeeMeeting;

        // send request
        const response: Promise<Dtos.ValidateCommitteeMeetingResponse> = client.post(request);

        return Observable.from(response);
    },
}